import { CloudFunctions } from "../../components/FirebaseAuth/firebase";

let metadataCache = null;
let metadataCacheTime = 0;
const METADATA_TTL_MS = 5 * 60 * 1000;

const fallbackMetadata = () => ({
  ip: "",
  location: "",
  user_agent: navigator.userAgent || "",
});

export const getClientMetadata = async () => {
  const now = Date.now();
  if (metadataCache && (now - metadataCacheTime) < METADATA_TTL_MS) {
    return metadataCache;
  }

  try {
    const fn = CloudFunctions.httpsCallable("getClientMetadata");
    const result = await Promise.race([
      fn({}),
      new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), 2500)),
    ]);
    const data = result?.data || {};
    metadataCache = {
      ip: data?.ip || "",
      location: data?.location || "",
      user_agent: data?.user_agent || navigator.userAgent || "",
    };
    metadataCacheTime = now;
    return metadataCache;
  } catch (_error) {
    metadataCache = fallbackMetadata();
    metadataCacheTime = now;
    return metadataCache;
  }
};
